<template>
  <div class="container">
    <form class="needs-validation" id="page-form" @submit.prevent="validateBeforeSubmit($event, proceed)" data-toggle="validator" novalidate>
      <div class="form-group-container">
        <h1 class="page-title">Register</h1>
        <div class="introduction row">
          <div class="col-12">

          </div>
        </div>
        <div class="col-12 col-lg-12 clear-padding-left" v-if="this.addSuccessful">
          <div class="alert alert-success">
            <p class="">Thank you for registering, your registration is confirmed.</p>
          </div>
        </div>
        <div class="col-12 col-lg-12 clear-padding-left" v-if="this.submitMessage !== ''">
          <div class="alert alert-danger">
            <p class="">{{this.submitMessage}}</p>
          </div>
        </div>
        <div class="col-12 col-md-10 center-align" v-if="!this.addSuccessful">

        </div>
      </div>
    </form>

  </div>
</template>

<script>
/* eslint-disable */
import { UserService } from "@/services/UserServices/UserService";
import Tooltip from "@/components/controls/Tooltip.vue";
import Textbox from "@/components/controls/Textbox.vue";
import Textarea from "@/components/controls/Textarea.vue";
import rbValidator from "@/mixins/rbValidator";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";
import formUpdateMixin from "@/mixins/formUpdateMixin";

// import {
//   productComputed,
//   productMethods,
//   productMutations
// } from "@/state/helpers";

export default {
  name: "ConfirmEmail",
  mixins: [formUpdateMixin, commonMixin, rbValidator],
  props: [],
  components: {
    Tooltip,
    Textbox,
    Textarea
  },
  data() {
    return {
      addSuccessful: false,
      loaded: true,
      submitMessage: "",
      item: {
        userId: "",
        code: ""
      }
    };
  },
  methods: {
    async confirmEmail() {
      this.submitMessage = "";
      var response = await UserService.confirmEmail(
        JSON.parse(JSON.stringify(this.item))
      );
      if (response.success) {
        this.addSuccessful = true;
        //this.redirectToRoute("/login");
        this.$router.push("/login");
        // setTimeout(() => {
          
        // }, 400);
      }
      this.loaded = true;
    }
  },
  computed: {},
  created() {
    this.item.userId = this.$route.params.id;
    this.item.code = this.$route.params.code;
    this.confirmEmail();
  },
  mounted() {}
};
</script>

<style scoped>
</style>
